import styled from 'styled-components';

const AskAnotherQuestionWrapper = styled.nav`
  flex-grow: 1;
  text-align: center;
`;

export default AskAnotherQuestionWrapper;
